module.exports = __webpack_public_path__ + "img/macOS-active.15f33b7.svg";